'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Cookies = require('Cookies');

var _Cookies2 = _interopRequireDefault(_Cookies);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _CookieSetError = require('./errors/CookieSetError');

var _CookieSetError2 = _interopRequireDefault(_CookieSetError);

var _RedirectError = require('./errors/RedirectError');

var _RedirectError2 = _interopRequireDefault(_RedirectError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VISIT_MARKER_TEMPLATE = 'visited.${lb}.at';
var CSRF_KEY_TEMPLATE = 'csrf.${lb}';
var URL_LOADED = _Url2.default.loaded;
var IS_SAFARI = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');

var BaseCookieLogin = function () {
  function BaseCookieLogin(cookieLoadBalancers, loginRequest, prepRequest, visitPath) {
    _classCallCheck(this, BaseCookieLogin);

    this.cookieLoadBalancers = cookieLoadBalancers;
    this.prepRequest = prepRequest;
    this.loginRequest = loginRequest;
    this.visitPath = visitPath;
    this.currentDomain = '.' + location.hostname.split('.').slice(-2).join('.');

    this.domainPreps = this.domainPreps.bind(this);
    this.collectDomainPreps = this.collectDomainPreps.bind(this);
    this.collectLoginResponses = this.collectLoginResponses.bind(this);
  }

  _createClass(BaseCookieLogin, [{
    key: 'loginPrep',
    value: function loginPrep() {
      var _this = this;

      if (!this.loginPrepPromise) {
        if (IS_SAFARI) {
          this.loginPrepPromise = _q2.default.Promise.all(this.domainPreps()).then(function (preps) {
            return _this.collectDomainPreps.apply(_this, _toConsumableArray(preps));
          }).catch(function (error) {
            console.error(error);
            if (error.name === 'RedirectError') {
              throw error;
            }
          });
        } else {
          this.loginPrepPromise = _q2.default.Promise.resolve();
        }
      }
      return this.loginPrepPromise;
    }
  }, {
    key: 'domainPreps',
    value: function domainPreps() {
      return this.cookieLoadBalancers.map(this.prepRequest);
    }
  }, {
    key: 'collectDomainPreps',
    value: function collectDomainPreps() {
      var _this2 = this;

      var redirectLoadBalancers = [];

      for (var _len = arguments.length, domainPreps = Array(_len), _key = 0; _key < _len; _key++) {
        domainPreps[_key] = arguments[_key];
      }

      domainPreps.forEach(function (_ref, i) {
        var visited = _ref.visited;

        var loadBalancer = _this2.cookieLoadBalancers[i];
        var marker = VISIT_MARKER_TEMPLATE.replace('${lb}', loadBalancer);
        if (visited) {
          _hubspot2.default.removeItem(marker);
        } else {
          var maybeMarkerTimestamp = _hubspot2.default.getItem(marker);
          var markerSetAt = maybeMarkerTimestamp != null ? +maybeMarkerTimestamp : 0;
          var now = new Date().getTime();
          if (now - markerSetAt < 120000) {
            _hubspot2.default.removeItem(marker);
            throw new _CookieSetError2.default();
          }
          redirectLoadBalancers.push(loadBalancer);
          _hubspot2.default.setItem(marker, now);
        }
      });
      this.visitUnvisited(redirectLoadBalancers);
    }
  }, {
    key: 'visitUnvisited',
    value: function visitUnvisited(loadBalancers) {
      var _this3 = this;

      if (loadBalancers.length) {
        var visitUrl = URL_LOADED.clone().href;
        loadBalancers.forEach(function (loadBalancer) {
          visitUrl = new _Url2.default(_this3.visitPath, {
            lb: loadBalancer,
            params: { redirect: visitUrl }
          }).href;
        });
        window.location = visitUrl;
        throw new _RedirectError2.default();
      }
    }
  }, {
    key: 'login',
    value: function login(credentials) {
      var _this4 = this;

      return this.loginPrep().then(function () {
        return _q2.default.Promise.all(_this4.loginRequests(credentials)).then(function (responses) {
          return _this4.collectLoginResponses.apply(_this4, _toConsumableArray(responses));
        });
      }).catch(function (response) {
        try {
          response.responseJSON = response.responseJSON || JSON.parse(response.responseText);
        } catch (ex) {
          console.error('Unable to parse error response JSON "' + response.responseText + '"');
        }
        throw response;
      });
    }
  }, {
    key: 'loginRequests',
    value: function loginRequests(credentials) {
      var _this5 = this;

      return this.cookieLoadBalancers.map(function (loadBalancer) {
        return _this5.loginRequest(credentials, loadBalancer);
      });
    }
  }, {
    key: 'collectLoginResponses',
    value: function collectLoginResponses() {
      var _this6 = this;

      for (var _len2 = arguments.length, loginResponses = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        loginResponses[_key2] = arguments[_key2];
      }

      loginResponses.forEach(function (_ref2, i) {
        var csrfToken = _ref2.csrfToken;

        var csrfKey = CSRF_KEY_TEMPLATE.replace('${lb}', _this6.cookieLoadBalancers[i]);
        _Cookies2.default.set(csrfKey, csrfToken, { path: '/', secure: true, expires: 365, domain: _this6.currentDomain });
      });
      return loginResponses;
    }
  }, {
    key: 'ignoreRedirectWrapper',
    value: function ignoreRedirectWrapper(failureHandler) {
      return function (response) {
        if (response.name !== 'RedirectError') {
          failureHandler(response);
        }
      };
    }
  }]);

  return BaseCookieLogin;
}();

exports.default = BaseCookieLogin;
module.exports = exports['default'];